import { render, staticRenderFns } from "./inout-moves.vue?vue&type=template&id=4fba1799&"
import script from "./inout-moves.vue?vue&type=script&lang=ts&"
export * from "./inout-moves.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports